/**
 * De que estado é o contato — lido do DDD do telefone.
 *
 * A ficha não tem campo de estado, e não precisa: todo caso chega pelo
 * WhatsApp, e o DDD já diz a UF. Campo digitado envelheceria ao lado de um dado
 * que o telefone carrega de graça.
 *
 * Folha pura (sem banco): a tela importa este mesmo arquivo para a bandeira da
 * lista, e o painel da carteira usa para o mapa. Duas tabelas de DDD seriam
 * duas respostas para "de onde é".
 *
 * ponytail: DDD é a linha, não a pessoa — quem se mudou com o número continua
 * no estado antigo. Se o escritório começar a guardar endereço, o endereço vence.
 */

export const ESTADOS: Record<string, string> = {
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

const DDDS: Record<string, string> = {
  AC: "68",
  AL: "82",
  AP: "96",
  AM: "92 97",
  BA: "71 73 74 75 77",
  CE: "85 88",
  DF: "61",
  ES: "27 28",
  GO: "62 64",
  MA: "98 99",
  MT: "65 66",
  MS: "67",
  MG: "31 32 33 34 35 37 38",
  PA: "91 93 94",
  PB: "83",
  PR: "41 42 43 44 45 46",
  PE: "81 87",
  PI: "86 89",
  RJ: "21 22 24",
  RN: "84",
  RS: "51 53 54 55",
  RO: "69",
  RR: "95",
  SC: "47 48 49",
  SP: "11 12 13 14 15 16 17 18 19",
  SE: "79",
  TO: "63",
};

const UF_DO_DDD = new Map(Object.entries(DDDS).flatMap(([uf, lista]) => lista.split(" ").map((d) => [d, uf] as const)));

/**
 * A UF do telefone, ou `null` quando não dá para dizer.
 *
 * Aceita as formas que o banco tem ("(47) 99612-4408", "5547996124408"). Número
 * com DDI de fora (`+` que não é +55, ou 12+ dígitos sem o 55) é `null`, e não o chute dos dois
 * primeiros dígitos: bandeira errada é pior que bandeira nenhuma.
 */
export function ufDoTelefone(telefone: unknown): string | null {
  const bruto = String(telefone ?? "").trim();
  /* "+1 415 555 0100" também tem 11 dígitos, e o 14 seria São Paulo. */
  if (bruto.startsWith("+") && !bruto.replace(/[^\d+]/g, "").startsWith("+55")) return null;
  const so = bruto.replace(/\D/g, "");
  const nacional = so.length > 11 && so.startsWith("55") ? so.slice(2) : so;
  if (nacional.length < 10 || nacional.length > 11) return null;
  return UF_DO_DDD.get(nacional.slice(0, 2)) ?? null;
}
